import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagementService, SiteConfig } from '../../core/services/management.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-management',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ToolbarModule,
    DialogModule,
    InputTextModule,
    PasswordModule,
    ReactiveFormsModule
  ],
  template: `
    <div class="p-8">
      <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <h1 class="text-2xl font-bold m-0">Site Access Management</h1>
        </ng-template>
        <ng-template pTemplate="right">
            <p-button label="New Site" icon="pi pi-plus" (onClick)="openNew()"></p-button>
        </ng-template>
      </p-toolbar>

      <p-table [value]="sites()" [loading]="loading()" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
            <tr>
                <th>Host</th>
                <th>Description</th>
                <th>Enabled</th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-site>
            <tr>
                <td>{{site.Host}}</td>
                <td>{{site.Description}}</td>
                <td>
                    <i class="pi" [ngClass]="{'pi-check-circle text-green-500': site.Enabled, 'pi-times-circle text-red-500': !site.Enabled}"></i>
                </td>
                <td>
                    <p-button icon="pi pi-pencil" styleClass="p-button-rounded p-button-text" (onClick)="editSite(site)"></p-button>
                    <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger" (onClick)="deleteSite(site)"></p-button>
                </td>
            </tr>
        </ng-template>
      </p-table>

      <p-dialog [(visible)]="siteDialog" [style]="{width: '450px'}" header="Site Details" [modal]="true" styleClass="p-fluid">
        <ng-template pTemplate="content">
            <form [formGroup]="siteForm">
                <div class="field mb-4">
                    <label for="host">Host</label>
                    <input type="text" pInputText id="host" formControlName="host" required autofocus />
                </div>
                <div class="field mb-4">
                    <label for="description">Description</label>
                    <input type="text" pInputText id="description" formControlName="description" />
                </div>
                <div class="field mb-4">
                    <label for="password">Password</label>
                    <p-password id="password" formControlName="password" [toggleMask]="true" [feedback]="false"></p-password>
                    <small *ngIf="isEditMode" class="block mt-1 text-gray-500">Leave blank to keep existing password</small>
                </div>
            </form>
        </ng-template>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text" (onClick)="hideDialog()"></p-button>
            <p-button label="Save" icon="pi pi-check" styleClass="p-button-text" (onClick)="saveSite()"></p-button>
        </ng-template>
      </p-dialog>
    </div>
  `
})
export class ManagementComponent implements OnInit {
  private mgmtService = inject(ManagementService);
  private fb = inject(FormBuilder);

  sites = signal<any[]>([]);
  loading = signal(false);
  siteDialog = false;
  isEditMode = false;

  siteForm = this.fb.group({
    host: ['', Validators.required],
    description: [''],
    password: [''],
    enabled: [true]
  });

  ngOnInit() {
    this.loadSites();
  }

  loadSites() {
    this.loading.set(true);
    this.mgmtService.getSites().subscribe({
      next: (data) => {
        this.sites.set(data);
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

  openNew() {
    this.isEditMode = false;
    this.siteForm.reset({ enabled: true });
    this.siteDialog = true;
  }

  editSite(site: any) {
    this.isEditMode = true;
    this.siteForm.patchValue(site);
    // Disable host editing in real implementation or handle PK change
    this.siteForm.get('host')?.disable(); 
    this.siteDialog = true;
  }

  deleteSite(site: any) {
      // Confirm and delete
  }

  hideDialog() {
    this.siteDialog = false;
  }

  saveSite() {
      if (this.siteForm.valid) {
          // Call service to create/update
          // Refresh list
          this.siteDialog = false;
      }
  }
}


